import cookie from '../cookie/cookie'
import query from './src/query'

const sources = [
  'utm_term',
  'utm_medium',
  'utm_source',
  'utm_content',
  'utm_campaign',
  'agx_hash',
  'affiliate_id',
  'affiliate_click_id',
  'affiliate_unique5',
  'affiliate_sub3',
  'affiliate_sub5',
  'affiliate_source',
  'offers_id',
  'clickid',
  'goalid_1',
  'goalid_2',
  'goalid_3',
  'goalid_4',
  'goalid_5',
  'aff_sub4',
  'aff_sub5',
  'gclid',
  'ttclid',
  'fbclid',
  'cupom',
  'cp', // falback to cupom used to crm
  'futm_jwt',
  'futm_exp_variant',
  'futm_user_interest',
]

const collection = {
  method: 'GET',
  title: document.title,
  url: window.location.href,
  userAgent: navigator.userAgent,
}

const mappedToCookie = () => {
  sources.forEach((source) => {
    const queryValue = query.getByName(source)
    if (!queryValue) return

    let maxAge

    if (source === 'futm_jwt') {
      maxAge = 24 * 60 * 60
    }

    cookie.set(source, queryValue, maxAge)
    collection[source] = queryValue
  })

  if (
    document.referrer &&
    !document.referrer.startsWith('https://www.foregon.com') &&
    !document.referrer.startsWith('https://accounts.google.com')
  ) {
    cookie.set('referrer_external', document.referrer)
  }

  cookie.set('referrer', document.referrer)
}

const sendToAnalyze = (api, body = {}) => {
  fetch(api, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    keepalive: true,
    body: JSON.stringify(body),
  })
}

const flatten = (obj, parentKey = '', result = {}) => {
  Object.entries(obj).forEach(([key, value]) => {
    const newKey = parentKey ? `${parentKey}_${key}` : key
    if (typeof value === 'object' && !Array.isArray(value)) {
      // eslint-disable-next-line no-unused-vars
      flatten(value, newKey, result)
    } else {
      result[newKey] = value
    }
  })
  return result
}

const trackMoengage = async () => {
  const allowedUrls = ['https://www.foregon.com/minha-conta/']

  if (!allowedUrls.some((url) => new RegExp(url).test(window.location.href))) {
    return
  }

  const moeDataCenter = 'dc_2'
  const moeAppID = 'BLWI77PFE79FMTN49QITW2RV'

  // eslint-disable-next-line
  !function (e, n, i, t, a, r, o, d) { if (!moeDataCenter || !moeDataCenter.match(/^dc_[0-9]+$/gm)) return console.error("Data center has not been passed correctly. Please follow the SDK installation instruction carefully."); var s = e[a] = e[a] || []; if (s.invoked = 0, s.initialised > 0 || s.invoked > 0) return console.error("MoEngage Web SDK initialised multiple times. Please integrate the Web SDK only once!"), !1; e.moengage_object = a; var l = {}, g = function n (i) { return function () { for (var n = arguments.length, t = Array(n), a = 0; a < n; a++)t[a] = arguments[a]; (e.moengage_q = e.moengage_q || []).push({ f: i, a: t }) } }, u = ["track_event", "add_user_attribute", "add_first_name", "add_last_name", "add_email", "add_mobile", "add_user_name", "add_gender", "add_birthday", "destroy_session", "add_unique_user_id", "update_unique_user_id", "moe_events", "call_web_push", "track", "location_type_attribute"], m = { onsite: ["getData", "registerCallback"] }; for (var c in u) l[u[c]] = g(u[c]); for (var v in m) for (var f in m[v]) null == l[v] && (l[v] = {}), l[v][m[v][f]] = g(v + "." + m[v][f]); r = n.createElement(i), o = n.getElementsByTagName("head")[0], r.async = 1, r.src = t, o.appendChild(r), e.moe = e.moe || function () { return (s.invoked = s.invoked + 1, s.invoked > 1) ? (console.error("MoEngage Web SDK initialised multiple times. Please integrate the Web SDK only once!"), !1) : (d = arguments.length <= 0 ? void 0 : arguments[0], l) }, r.addEventListener("load", function () { if (d) return e[a] = e.moe(d), e[a].initialised = e[a].initialised + 1 || 1, !0 }), r.addEventListener("error", function () { return console.error("Moengage Web SDK loading failed."), !1 }) }(window, document, "script", "https://cdn.moengage.com/release/" + moeDataCenter + "/moe_webSdk.min.latest.js", "Moengage");

  // eslint-disable-next-line
  Moengage = moe({
    app_id: moeAppID,
    swPath: '/serviceworker.js',
  })

  try {
    const result = await fetch('/api/v5/tracking/frontend-payload')
    const obj = await result.json()

    const horusid = obj && obj.userInfo && obj.userInfo.horusid
    if (horusid) {
      await window.Moengage.add_unique_user_id(horusid)
    }

    window.Moengage.track_event(`fe_pageview`, flatten(obj))
  } catch (error) {
    /**/
  }
}

const mappedToId = () => {
  if (window.__product__) {
    const product = JSON.parse(window.__product__)
    if (product && product.id) collection.productId = product.id
  }
}

const mount = () => {
  mappedToId()
  mappedToCookie()
}

const send = ({ credentials } = {}) => {
  if (credentials) {
    sendToAnalyze('https://www.foregon.com/account/api/ping')
  }

  sendToAnalyze('https://www.foregon.com/account/api/log', collection)
  trackMoengage()
}

export default { mount, send }
